import React from 'react';
import styled from 'styled-components';

export const Card = ({ title, ...other }) => (
  <div>
    {title && <Title>{title}</Title>}
    <StyledCard {...other} />
  </div>
);

const Title = styled.div`
  color: #475059;
  font-weight: bold;
  margin-bottom: 8px;
`;

export const StyledCard = styled.div`
  border-radius: 4px;
  background: white;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1), 0 -100px 0 transparent inset;
`;
